import { render } from "./CookiesDialog.vue?vue&type=template&id=1127a30e&ts=true"
import script from "./CookiesDialog.vue?vue&type=script&lang=ts"
export * from "./CookiesDialog.vue?vue&type=script&lang=ts"

import "./CookiesDialog.vue?vue&type=style&index=0&id=1127a30e&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__